import React from 'react';
import { Modal, Table } from 'antd';
import { ames247Axios } from 'configs/api';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Button from 'reactstrap/lib/Button';
import Ditail from './DetailComponent';
import useSWR from 'swr';

const StudentNotificationComponent = (props) => {
  // const params = useParams();
  const loggedInUser = useSelector((rootState) => rootState.authReducer.loggedInUser);
  //useSWR
  const classId = '5203';
  const studentId = loggedInUser?.id;
  // const { data, error, mutate, isValidating } = useSWR(
  const { data, mutate } = useSWR(`https://cloud.softech.cloud/mobile/sgk/api/GetNotificationsByStudent/${studentId}/${classId}`, (Url) => ames247Axios.get(Url).then((res) => res.data.result ?? []), { dedupingInterval: 0 });
  //
  const [state, setState] = React.useState({
    isModal: false,
    ListData: [],
    id_ditail: null,
  });
  //
  React.useEffect(() => {
    setState((pre) => ({ ...pre, ListData: data?.reverse() ?? [] }));
  }, [data]);
  //
  const child = (title, dataIndex, key, width, fixed = false, render) => {
    return {
      key,
      title,
      fixed,
      dataIndex,
      // align: 'center',
      width: width ? width : 100,
      render,
    };
  };
  const column = [
    child('STT', 'stt', 'stt', '10%'),
    child('Tiêu đề', 'title', 'title', '20%'),
    child('Nội dung', 'content', 'content', '40%'),
    child('Ngày tạo', 'date', 'date', '20%'),
    child('#', 'detail', 'detail', '10%', false, (text, record) => {
      return (
        <div style={{ whiteSpace: 'nowrap' }}>
          <Button onClick={() => showModal(record.id)} style={{ padding: '5px 2px', height: 'fit-content' }}>
            <Link to='#'>
              <i className='fas fa-info mx-1'></i> Chi tiết
            </Link>
          </Button>
        </div>
      );
    }),
  ];
  //Modal
  const showModal = (id) => {
    setState((pre) => ({ ...pre, isModal: true, id_ditail: id }));
  };
  const handleModalOk = () => {
    setState((pre) => ({ ...pre, isModal: false }));
  };
  const handleCancel = () => {
    setState((pre) => ({ ...pre, isModal: false }));
  };
  //
  const DataTable = React.useCallback((ListData) => {
    return ListData.map((item, index) => {
      const Title = item.title;
      const CreatedDate = item.CreatedDate;
      const Content = item.content;
      let Text = '';
      try {
        Text = JSON.parse(Content).blocks[0].text;
      } catch (e) {
        Text = Content;
      }
      return {
        id: item.id,
        stt: index + 1,
        title: Title,
        content: Text,
        date: CreatedDate,
      };
    });
  }, []);
  //
  return (
    <div
      onClick={() => {
        mutate();
      }}
    >
      <Table
        rowKey='id'
        columns={column}
        // dataSource={dataSource}
        dataSource={DataTable(state.ListData)}
      />
      <Modal title='Thông báo' visible={state.isModal} cancelButtonProps={{ hidden: true }} onOk={handleModalOk} onCancel={handleCancel}>
        <Ditail data={state?.ListData} id_ditail={state?.id_ditail} />
      </Modal>
    </div>
  );
};
export default StudentNotificationComponent;
